import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/paper_sizes/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listUnits, updateUnit } from "../../../redux/actions/table/superadmin/units";
import EditUnitForm from "../../../forms/superadmin/units/EditUnitForm";
import { listLocalization } from "../../../redux/actions/localization";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateUnit(formData.id, _.omit(formData, ['id'])).then(() => {
                listUnits();

                this.props.readAction(formData.id);

                listLocalization();

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditUnitForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'symbol', 'description', 'unit_group_id', 'coefficient']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
